<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ mainTitle }}</h4>
  <button
    type="button"
    class="close text-primary"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
    >
    <i class="fas fa-times-circle"></i>
  </button>
</div>
<div class="modal-body">
  <!-- <p>
  <strong>{{ msgVald }}</strong>
</p> -->
<p>
  {{ mainMessage }}
  <span class="text-danger"
    >¿Deseas continuar?</span
    >
  </p>
  @if (errorMessage) {
    <ngb-alert type="danger" (close)="errorMessage = ''">{{
      errorMessage
    }}</ngb-alert>
  }
  @if (successMessage) {
    <ngb-alert
      type="success"
      (close)="successMessage = ''"
      >{{ successMessage }}</ngb-alert
      >
    }
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="activeModal.dismiss('cancel click')"
      >
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      @if (loading) {
        <div>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Procesando...
        </div>
      }
      @if (!loading) {
        <span> Ok </span>
      }
    </button>
  </div>
